export default {
    methods: {
        /**
         * 超级提交完成后
         * @name superSubmitOk
         * @param formData 提交数据
         * @param isSupper 是否超级提交
         */
        submitOk(formData, isSupper) {
            this.queryModuleData();
            this.$emit('submitOk', formData, isSupper)
        }
    }
}
  
